import ObjectionsBar from './ObjectionsBar'
export default ObjectionsBar;